import React from 'react';
import classes from './call-error.module.scss';
import cn from 'classnames';
import { isMobile } from 'react-device-detect';

const CallError = () => {
  return (
    <div className={cn(classes.callError, {
      [classes.callError_mobile]: isMobile,
      [classes.callError_desktop]: !isMobile,
    })}>
      <div className={classes.callError__main}>
        <div className={classes.callError__error}>
          Сервис временно недоступен
        </div>
      </div>
      <button
        className={cn(classes.callError__button, classes.button)}
        onClick={() => window.location.reload()}
      >
        <span className={classes.button__text}>Попробовать снова</span>
      </button>
    </div>
  );
}

export default CallError;